"use client";
import { createGlobalStyle } from "styled-components";
import TexgyreherosRegular from "./Texgyreheros-Regular.woff2.js";
import TexgyreherosBold from "./Texgyreheros-Bold.woff2.js";
const AutoriaFont = createGlobalStyle`

@font-face {
    font-family: 'TeX Gyre Heros';
    src: url(${TexgyreherosRegular});
    font-weight: 400;
}

// Missing Medium font-weight
@font-face {
    font-family: 'TeX Gyre Heros';
    src: url(${TexgyreherosRegular});
    font-weight: 500;
}

// Missing SemiBold font-weight
@font-face {
    font-family: 'TeX Gyre Heros';
    src: url(${TexgyreherosBold});
    font-weight: 600;
}

@font-face {
    font-family: 'TeX Gyre Heros';
    src: url(${TexgyreherosBold});
    font-weight: 700;
}
`;
export {
  AutoriaFont
};
